<template>
<v-card min-height="10">
    <v-container v-if="widget_data" fluid class="pa-0 ma-0">
        <v-card-text>
            <div class="d-flex justify-space-between">
                <div class="d-flex align-center">
                    <v-icon large class="mr-3">table_chart</v-icon>
                    <div>
                        <div class="subheading text-uppercase">Top Hotel Sales</div>
                        <div class="heading grey--text">
                            {{from}}
                            <v-icon small>arrow_right_alt</v-icon>
                            {{until}}
                        </div>
                    </div>

                </div>
                <v-col cols="4">
                    <v-select v-model="limit" :items="[5, 10, 25, 50, 100, 1000]" hide-details filled label="Limit" />
                </v-col>
            </div>
        </v-card-text>
        <v-divider class="mx-3" />
        <v-card-text>
            <v-data-table :headers="widget_headers" :items="widget_data" hide-default-footer must-sort disable-pagination>
                <template v-slot:items="props">
                    <td>{{ props.index + 1 }}</td>
                    <td>{{ props.item.hotel }}</td>
                    <td>{{ props.item.city }}, {{ props.item.country }}</td>
                    <td class="text-right monospaced">{{ props.item.bookings }}</td>
                    <td class="text-right monospaced">{{ props.item.sales }}</td>
                </template>
            </v-data-table>
        </v-card-text>
    </v-container>
    <v-container v-else fill-height class="pa-2 ma-0">
        <v-card-text>
            <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular :size="75" color="primary" indeterminate />
            </div>
        </v-card-text>
    </v-container>
</v-card>
</template>

<script>
export default {

    props: {
        url: String,
        from: String,
        until: String,
    },

    watch: {
        from: function () {
            this.getWidget();
        },
        until: function () {
            this.getWidget();
        },
        limit: function () {
            this.getWidget();
        }
    },

    methods: {
        getWidget() {
            this.widget_data = null;
            this.$axios
                .get(this.url + "/hotel-sales-report", {
                    params: {
                        from: this.from,
                        until: this.until,
                        limit: this.limit
                    }
                })
                .then(response => {
                    this.widget_data = response.data;
                });
        }
    },

    created() {
        this.getWidget();
    },

    data() {
        return {
            limit: 5,
            widget_data: null,
            widget_headers: [
                {
                    text: 'Hotel',
                    value: 'hotel',
                    sortable: false
                },
                {
                    text: 'Locality',
                    value: 'city',
                    sortable: true
                },
                {
                    text: 'Bookings',
                    align: 'right',
                    value: 'bookings'
                },
                {
                    text: 'Sales (€)',
                    align: 'right',
                    value: 'sales'
                },
                ],
            pagination: {
                sortBy: 'sales',
                descending: true,
                rowsPerPage: -1
            },
        }
    }
}
</script>

<style>
.monospaced {
    font-family: 'Roboto Mono', monospace;
}
</style>
